import React, { useCallback } from 'react';
import styled from 'styled-components';
import SavedDrafts from './SavedDrafts';
import DraftBoard from './DraftBoard';
import { useDraft } from '../contexts/DraftContext';

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const DraftsPageContent = () => {
  const { 
    scenariosFirstPick, 
    updateScenario,
    setTeamName,
    setTournament,
    setDraftDate
  } = useDraft();

  const handleMatchDataPulled = useCallback((matchData) => {
    try {
      // Update the first scenario with the pulled picks data
      if (scenariosFirstPick.length > 0) {
        updateScenario('first', scenariosFirstPick[0].id, { 
          picks: matchData.picks 
        });
      }
      
      // Update the context fields for consistency
      if (matchData.teamName) setTeamName(matchData.teamName);
      if (matchData.tournament) setTournament(matchData.tournament);
      if (matchData.date) setDraftDate(matchData.date);

    } catch (error) {
      console.error('Error handling pulled match data:', error);
    }
  }, [scenariosFirstPick, updateScenario, setTeamName, setTournament, setDraftDate]);

  return (
    <ContentContainer>
      <SavedDrafts onMatchDataPulled={handleMatchDataPulled} />
      <DraftBoard />
    </ContentContainer>
  );
};

export default DraftsPageContent;